<template>
  <div id="lb-get-product-mail" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <form id="form-instock-mail">
          <div class="modal-header">
            <h4 class="modal-title">貨到通知</h4>
            <a class="close" href="#" data-dismiss="modal" aria-label="Close">
              <i class="icon-remove-x" />
            </a>
          </div>
          <div class="modal-body">
            <input
              v-model="userMail"
              type="email"
              name="mail"
              placeholder="輸入E-mail"
              class="form-control"
              required
            />
            <p class="mt-1">*提醒您，此貨到通知不提供商品保留功能</p>
          </div>
          <div class="modal-footer">
            <div class="w-100">
              <button
                class="btn btn-primary w-100 d-block"
                type="button"
                @click.prevent="getNotice"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import AlertDialog from '@global/helpers/alertDialog';

export default {
  props: ['custommarketid'],
  data() {
    return {
      userMail: '',
    };
  },
  methods: {
    getNotice() {
      const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

      if (this.userMail.length !== 0 && regex.test(this.userMail)) {
        axios
          .post(API_URL.IN_STOCK_EMAIL, {
            CustomMarketID: this.custommarketid,
            Email: this.userMail,
          })
          .then((res) => {
            if (res.data.Code === 200) {
              AlertDialog.alert('貨到通知索取成功!謝謝您~', () => {
                $('#lb-get-product-mail').modal('hide');
              });
            } else {
              $('#lb-get-product-mail').modal('hide');
            }
          })
          .catch((error) => {
            AlertDialog.alert(error);
          });
      } else {
        AlertDialog.alert('請輸入有效Email');
      }
    },
  },
};
</script>
